import axios from 'axios'
import { attachAuthRefresh } from './authInterceptor'

// Wave Final (P1-F13): в production отсутствие REACT_APP_API_URL должно
// падать явно, а не молча уводить запросы на localhost (CORS error для юзера).
// В dev/test допускаем localhost-fallback, чтобы Storybook/Jest не ломались.
const fallbackUrl = 'https://sys.chu.kg/api/'
const envUrl = process.env.REACT_APP_API_URL
if (!envUrl && process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.error(
    '[CHU] REACT_APP_API_URL не задан в production-сборке. ' +
      'Запросы будут падать. Установите ENV в build-pipeline.',
  )
}
export const API_URL = envUrl || fallbackUrl

const $api = axios.create({
  withCredentials: true,
  baseURL: API_URL,

  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

$api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  // For FormData payloads, let the browser/axios set the multipart
  // boundary automatically by removing the JSON Content-Type override.
  if (
    typeof FormData !== 'undefined' &&
    config.data instanceof FormData &&
    config.headers
  ) {
    delete config.headers['Content-Type']
    if (config.headers.common) delete config.headers.common['Content-Type']
  }
  return config
})

// 401 → refresh → retry; при провале — clear + redirect /login.
attachAuthRefresh($api)

export default $api
